<template>
	<label
		:class="[
			'selector',
			{
				'selector--v3': isV3,
			},
		]"
	>
		<p v-if="title" class="selector__title">
			{{ title }}
		</p>
		<select
			:disabled="disabled"
			:value="value"
			class="selector__select"
			@change="change"
			@keydown.enter="$emit('enter')"
		>
			<option
				v-for="item in optionList"
				:key="item[valueKey]"
				:value="item[valueKey]"
				:selected="item[valueKey] === value"
			>
				{{ item[nameKey] }}
			</option>
		</select>
	</label>
</template>
<script>
	export default {
		name: 'Selector',
		props: {
			value: {
				type: [String, Number, Boolean],
				default: null,
			},
			title: {
				type: String,
				default: '',
			},
			optionList: {
				type: Array,
				default: [],
			},
			nameKey: {
				type: String,
				default: 'name',
			},
			valueKey: {
				type: String,
				default: 'value',
			},
			isV3: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},
		methods: {
			change(e) {
				const target = e.target;
				const targetObj = this.optionList.filter(
					(item, idx) => target[idx].value === target.value
				)[0];
				this.$emit('input', targetObj[this.valueKey]);
				this.$emit('checkName', targetObj.name);
			},
		},
	};
</script>
<style lang="scss" scoped>
	LABEL {
		.selector {
			display: flex;
			align-items: center;
		}

		.selector__title {
			margin-right: 4px;
		}

		.selector__select {
			max-width: 100%;
			height: 36px;
			padding: 0 8px;
			border: solid 1px #dfe6ee;

			&:focus {
				outline: 1px solid #0099fa;
			}
		}
	}

	.selector--v3 {
		display: flex;
		align-items: center;

		.selector__title {
			margin-right: 4px;
		}

		.selector__select {
			background-color: lightblue;
			padding: 0 12px;
			border: 0;
		}
	}

	.selector {
		background-color: white;
	}
</style>
